import actions from '../Actions/actions';

const initialState = {
    fetching: false,
    fetched: false,
    error: null,
    statusCode: null,

    animals: [
        /*
        {
            AnimalBreedId: 1
            AnimalDisplayName: "Katten Jansson"
            AnimalGender: "Male"
            AnimalType: "cat"
            InsuranceObjectId: 12345
        }
        */
    ]
};

export default function customerAnimals(state = initialState, action = {}) {
    let returnState = {...state};

    switch (action.type) {
        case actions.CUSTOMER_ANIMALS_FETCHING_SET:
            returnState = {
                ...state,
                fetching: !!action.payload
            };
            break;
        case actions.CUSTOMER_ANIMALS_SET:
            returnState = {
                ...state,
                animals: action.payload
            };
            break;
    }

    return returnState;
}